module.exports = false;



//////////////////
// WEBPACK FOOTER
// C:/Users/sgarciadarosa/Documents/TestApps/angular-notification/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 0